/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SkillEfficacyInsight,
  SkillEfficacyInsight$inboundSchema,
} from "./skillefficacyinsight.js";
import {
  SkillEfficacyScoredSession,
  SkillEfficacyScoredSession$inboundSchema,
} from "./skillefficacyscoredsession.js";

export type SkillEfficacyInsightsResult = {
  from: Date;
  insights: Array<SkillEfficacyInsight>;
  intervalSeconds: number;
  /**
   * Cursor for the next page of scored sessions; absent when exhausted.
   */
  nextCursor?: string | undefined;
  scoredSessions: Array<SkillEfficacyScoredSession>;
  scoresAvailable: boolean;
  to: Date;
};

/** @internal */
export const SkillEfficacyInsightsResult$inboundSchema: z.ZodMiniType<
  SkillEfficacyInsightsResult,
  unknown
> = z.pipe(
  z.object({
    from: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    insights: z.array(SkillEfficacyInsight$inboundSchema),
    interval_seconds: z.int(),
    next_cursor: z.optional(z.string()),
    scored_sessions: z.array(SkillEfficacyScoredSession$inboundSchema),
    scores_available: z.boolean(),
    to: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
  }),
  z.transform((v) => {
    return remap$(v, {
      "interval_seconds": "intervalSeconds",
      "next_cursor": "nextCursor",
      "scored_sessions": "scoredSessions",
      "scores_available": "scoresAvailable",
    });
  }),
);

export function skillEfficacyInsightsResultFromJSON(
  jsonString: string,
): SafeParseResult<SkillEfficacyInsightsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillEfficacyInsightsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillEfficacyInsightsResult' from JSON`,
  );
}
